const BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

function getToken(): string | null {
  try {
    const raw = localStorage.getItem('reevol-auth');
    if (!raw) return null;
    const state = JSON.parse(raw);
    return state?.state?.token ?? null;
  } catch {
    return null;
  }
}

export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: { ...headers, ...((options?.headers as Record<string, string>) ?? {}) },
  });

  if (res.status === 401) {
    localStorage.removeItem('reevol-auth');
    // Preserve current search params (e.g. ?event=xxx&lang=zh) on auth redirect
    const currentParams = window.location.search;
    window.location.href = '/login' + currentParams;
    throw new ApiError('Unauthorized', 401);
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new ApiError(err.error || `API ${res.status}`, res.status);
  }

  return res.json();
}
